<template>
    <a :href="url">
        <Title :title="title"></Title>
        <el-row :gutter="2" style="margin-bottom: 0.2rem;">
            <el-col :span="16">
                <Image1 v-lazy="images[0]"
                        scale="16:9">
                </Image1>
            </el-col>
            <el-col :span="8">
                <el-row style="padding-bottom: 2px;">
                    <Image1 v-lazy="images[1]"
                            scale="16:9">
                    </Image1>
                </el-row>
                <el-row>
                    <Image1 v-lazy="images[2]"
                            scale="16:9">
                    </Image1>
                </el-row>
            </el-col>
        </el-row>
        <From :source="source" :createTime="createTime"></From>
    </a>
</template>

<script>
import Title from "./title";
import From from "./from";
import Image1 from "../image";
export default {
    name: "TopTitleBottomImage",
    components: {
        Title,
        Image1,
        From
    },
    data () {
        return {
            height: (window.screen.width * (9 / 16)) + 'px',
        }
    },
    props: {
        url: String,
        title: String,
        images: Array,
        source: String,
        createTime: Number
    }
}
</script>

<style scoped>
</style>
